import { render, staticRenderFns } from "./ListaAnexo.vue?vue&type=template&id=7b6a1b3c"
import script from "./ListaAnexo.vue?vue&type=script&lang=js"
export * from "./ListaAnexo.vue?vue&type=script&lang=js"
import style0 from "./ListaAnexo.vue?vue&type=style&index=0&id=7b6a1b3c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports